import { useEffect } from 'react';

/**
 * usePageTitle — sets <title> on mount, restores to the brand title on unmount.
 * Closes WCAG 2.4.2 (Page titled).
 */
export const usePageTitle = (title) => {
  useEffect(() => {
    const brand = 'Alwasl Recovery OS';
    if (!title) {
      document.title = brand;
      return undefined;
    }
    document.title = `${title} — ${brand}`;
    return () => { document.title = brand; };
  }, [title]);
};

export default usePageTitle;
